import config from './config';

const reuse = {};

function handleFailedEmit (error, success) {
  if (error) {
    console.error(error);
    if (config.development) {
      alert('A websocket emit has failed. Check the console for more details about this error.');
    }
  }
}

function connect (namespace) {
  // if (namespace && reuse[namespace]) {
  //   return Promise.resolve(reuse[namespace]);
  // }
  const endpoint = config.socketIoHost + (namespace ? '/' + namespace : '');
  const opts = Object.assign({ forceNew: true }, config.socketIoOptions || {});
  opts.withCredentials = true;
  opts.query = { sticky: Math.random().toString(16).substr(2) };
  const socket = window.io(endpoint, opts);
  reuse[namespace] = socket;
  if (namespace) {
    return Promise.resolve(socket);
  }
  return new Promise((resolve, reject) => {
    socket.once('connect', () => {
      resolve(socket);
    });
    socket.once('connect_error', (err) => {
      reject(err);
    });
  });
}


export default {
  reuse,
  connect,
  handleFailedEmit,
};

export {
  reuse,
  connect,
  handleFailedEmit,
};



// WEBPACK FOOTER //
// ./src/ws.js